import { TransitStatusEnum } from "./TransitStatusEnum";

export class Request {
    public transitId: string;
    public transitStatus: TransitStatusEnum;

    constructor(transitId: string, changeEnum: TransitStatusEnum) {
        this.transitId = transitId;
        this.transitStatus = changeEnum;
    }
}
